import { makeStyles } from "tss-react/mui"
import { toggleButtonClasses, toggleButtonGroupClasses } from "@mui/material"

export const useStyles = makeStyles()(({ spacing, mixins, palette }) => ({
  toggleButtonGroup: {
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      "&:not(:first-of-type)": {
        border: `1px solid ${palette.primary[200]}`
      }
    },

    [`& .${toggleButtonClasses.root}`]: {
      color: palette.primary[800],
      border: `1px solid ${palette.primary[200]}`,
      borderRadius: "3px",
      fontWeight: 400,

      "&:hover, &:focus": {
        backgroundColor: palette.secondary[50]
      },

      [`&.${toggleButtonClasses.disabled}`]: {
        color: palette.primary[100],
        borderColor: palette.primary[100]
      },

      [`&:not(:last-of-type).${toggleButtonClasses.disabled}`]: {
        borderRightColor: "transparent"
      },

      [`&.${toggleButtonClasses.selected}`]: {
        color: palette.secondary[800],
        backgroundColor: palette.secondary[100],
        borderColor: palette.secondary[300],

        "&:hover": {
          backgroundColor: palette.secondary[100]
        }
      },

      "&:first-of-type": {
        [`&.${toggleButtonClasses.selected}`]: {
          borderRight: `1px solid ${palette.primary[200]}`
        }
      },

      "&:last-of-type": {
        [`&.${toggleButtonClasses.selected}`]: {
          borderLeft: `1px solid ${palette.primary[200]}`
        }
      },

      // a11y: ring on :focus (pointer + keyboard) per the app's global convention; shadow variant avoids recoloring the grouped border, z-index lifts it above adjacent toggles so it isn't clipped
      "&:focus": {
        ...mixins.focusRing.shadow,
        position: "relative",
        zIndex: 1
      }
    },

    [`.${toggleButtonClasses.root}:not(:first-of-type).${toggleButtonClasses.selected} + .${toggleButtonClasses.root}`]:
      {
        borderLeft: `1px solid transparent !important`
      }
  },
  large: {
    [`& .${toggleButtonClasses.root}`]: {
      fontSize: "1rem",
      lineHeight: "1.125rem",
      padding: spacing(4)
    }
  },
  medium: {
    [`& .${toggleButtonClasses.root}`]: {
      fontSize: "0.875rem",
      lineHeight: "1.125rem",
      padding: spacing(2, 4)
    }
  },
  small: {
    [`& .${toggleButtonClasses.root}`]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      padding: spacing(1, 3)
    }
  }
}))
